import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DeviceApplicationStateService } from '@era/appmanagement-sdk';
import {
  DeviceApplicationStateResolverActions,
  DeviceApplicationStateApiActions,
} from './device-application-state.actions';
import { switchMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';

@Injectable()
export class DeviceApplicationStateEffects {
  loadAll$ = createEffect(() => {
    {
      return this.actions$.pipe(
        ofType(DeviceApplicationStateResolverActions.deviceApplicationStatesRequested),
        switchMap(() =>
          safeMap(
            this.service.getAllDeviceStates(),
            (states) => DeviceApplicationStateApiActions.deviceApplicationStatesLoaded({ states }),
            (error) => DeviceApplicationStateApiActions.deviceApplicationStatesLoadFailed({ error })
          )
        )
      );
    }
  });

  constructor(
    private readonly actions$: Actions,
    private readonly service: DeviceApplicationStateService
  ) {}
}
